module.exports = __webpack_public_path__ + "img/maps.3aeafb72.png";